
import filters from "@/filters";
import { Component, Prop, Vue } from "vue-property-decorator";
import { formDataAppend } from "@/functions/global.function";
import { Action } from "vuex-class";

@Component({
  components: {},
  filters,
})
export default class ModalBroadcastCompany extends Vue {
  @Action("adminJobFairOrganizerBroadcastCompany", { namespace: "admin" })
  private adminJobFairOrganizerBroadcastCompany: any;

  @Prop({ default: null })
  private data!: any;
  @Prop({ default: null })
  private jobFair!: any;

  private submit() {
    const formData = new FormData();
    formData.append("id", this.jobFair?.id);
    formData.append("subject", this.data.subject);
    formData.append("body", this.data.body);
    formDataAppend(formData, this.data.attachments, "attachments");
    this.adminJobFairOrganizerBroadcastCompany({
      params: formData,
      success: () => {
        this.$bvModal.hide("modal-broadcast-company");
      },
    });
  }
}
